import { api } from "@/lib/api";
import { AffirmationContent, StudioContentStatus } from "../schema";

const CONTENT_AFFIRMATION = "/content-affirmations";

export const ContentAffirmationService = {
  async findAll(filters?: {
    search?: string;
    status?: StudioContentStatus;
    categoryId?: string;
    authorCoachId?: string;
    tagId?: string;
    language?: string;
    page?: number;
    limit?: number;
  }): Promise<{ items: AffirmationContent[]; pagination: any }> {
    const params = new URLSearchParams();
    if (filters?.search) params.set("search", filters.search);
    if (filters?.status) params.set("status", filters.status);
    if (filters?.categoryId) params.set("categoryId", filters.categoryId);
    if (filters?.authorCoachId)
      params.set("authorCoachId", filters.authorCoachId);
    if (filters?.tagId) params.set("tagId", filters.tagId);
    if (filters?.language) params.set("language", filters.language);
    if (filters?.page) params.set("page", filters.page.toString());
    if (filters?.limit) params.set("limit", filters.limit.toString());

    return api.get<{ items: AffirmationContent[]; pagination: any }>(
      `${CONTENT_AFFIRMATION}?${params.toString()}`,
    );
  },

  async findOne(id: string): Promise<AffirmationContent> {
    return api.get<AffirmationContent>(`${CONTENT_AFFIRMATION}/${id}`);
  },

  async create(payload: any): Promise<AffirmationContent> {
    return api.post<AffirmationContent>(CONTENT_AFFIRMATION, payload);
  },

  async update(id: string, payload: any): Promise<AffirmationContent> {
    return api.patch<AffirmationContent>(
      `${CONTENT_AFFIRMATION}/${id}`,
      payload,
    );
  },

  async submitForReview(id: string): Promise<any> {
    return api.post(`${CONTENT_AFFIRMATION}/${id}/submit`, {});
  },

  async createVersion(id: string): Promise<{ id: string; version: number }> {
    return api.post(`${CONTENT_AFFIRMATION}/${id}/new-version`, {});
  },

  async archive(id: string): Promise<AffirmationContent> {
    return api.delete<AffirmationContent>(`${CONTENT_AFFIRMATION}/${id}`);
  },

  async restore(id: string): Promise<AffirmationContent> {
    return api.post<AffirmationContent>(
      `${CONTENT_AFFIRMATION}/${id}/restore`,
      {},
    );
  },
};
